import React, { useState } from 'react';

import { formatPrice } from 'common/formatters';

import {
  BUTTON_THEME_GREY_ADOBE,
  BUTTON_THEME_RED_ADOBE,
  BUTTON_THEME_GREEN_ADOBE,
} from 'client/components/ButtonDeprecated';
import SrText from 'client/components/SrText';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';

const SrListingWithdrawnAlertModal = ({ partner, onSubmit, onClose }) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const withdrawalFeeFormatted = formatPrice(partner.billingFees.withdrawalFee) || '';

  if (showConfirmationModal) {
    return (
      <SrSimpleMessageModal
        theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
        maxWidth="375"
        iconUrl="/images/question-mark-blue-tiny.svg"
        headline="Are you sure you want to withdraw WITHOUT charging a fee?"
        underline
        message={
          <SrText weight="600" font="greycliff" lineHeight="25px">
            Sunroom normally charges partners a fee when withdrawing their property. Have you
            double-checked with the team before making this decision?
          </SrText>
        }
        multiButtons={[
          {
            buttonText: 'Cancel',
            onButtonClick: onClose,
            buttonTheme: BUTTON_THEME_GREEN_ADOBE,
          },
          {
            buttonText: 'Withdraw with no fee',
            onButtonClick: () => {
              onSubmit({ chargeWithdrawalFee: false });
            },
            buttonTheme: BUTTON_THEME_GREY_ADOBE,
          },
        ]}
      />
    );
  }

  return (
    <SrSimpleMessageModal
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      maxWidth="375"
      iconUrl="/images/warnin-icon-dolars-red.svg"
      headline={`There is a withdraw fee of ${withdrawalFeeFormatted}. Are you sure you want to withdraw?`}
      underline
      message={
        <SrText weight="600" font="greycliff" lineHeight="25px">
          Sunroom charges a {withdrawalFeeFormatted} withdrawal fee to cover the costs to set up and
          bring the home to market. Please select below if the partner should be charged or not for
          withdrawing this listing. The partner should be charged in most cases.
        </SrText>
      }
      multiButtons={[
        {
          buttonText: `Withdraw & Invoice ${withdrawalFeeFormatted}`,
          onButtonClick: () => {
            onSubmit({ chargeWithdrawalFee: true });
          },
          buttonTheme: BUTTON_THEME_RED_ADOBE,
        },
        {
          buttonText: 'Cancel',
          onButtonClick: onClose,
          buttonTheme: BUTTON_THEME_GREY_ADOBE,
        },
      ]}
      subLabelText={
        <SrText
          weight="600"
          font="greycliff"
          lineHeight="25px"
          color="blue300"
          cursor="pointer"
          onClick={() => {
            setShowConfirmationModal(true);
          }}
        >
          Withdraw with no fee
        </SrText>
      }
      showSubLabelDecoration={false}
    />
  );
};

SrListingWithdrawnAlertModal.displayName = 'SrListingWithdrawnAlertModal';

export default SrListingWithdrawnAlertModal;
